class UseragentParser {
  constructor(uaString) {
    this.ua = uaString || globalThis.navigator?.userAgent;
  }

  getPlatform() {
    return this._categorizeUserAgent(this.ua);
  }

  getOS() {
    return this._detectOS(this.ua);
  }

  getResult() {
    return {
      ua: this.ua,
      platform: this.getPlatform(),
      os: this.getOS(),
    };
  }

  _categorizeUserAgent(uaString) {
    const tabletRegex = /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i;
    const mobileRegex =
      /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/;

    if (tabletRegex.test(uaString)) {
      if (uaString.includes("Instagram") && uaString.includes("Mobile")) {
        return "mobile";
      }

      // Opera Mini runs on Android but is a mobile browser, not a tablet
      if (/Opera M(obi|ini)/i.test(uaString)) {
        return "mobile";
      }

      return "tablet";
    }

    if (mobileRegex.test(uaString)) {
      return "mobile";
    }

    if (globalThis?.navigator?.userAgent.includes("Mac") && "ontouchend" in document) {
      //covering iOS tablets
      return "tablet";
    }

    return "desktop";
  }

  _detectOS(ua) {
    const uaString = ua.toLowerCase();

    if (uaString.includes("windows nt")) return "Windows";
    if (/iphone|ipad|ipod/.test(uaString)) return "iOS";
    if (uaString.includes("android")) return "Android";
    if (uaString.includes("mac os x") || uaString.includes("macintosh")) return "macOS";
    if (uaString.includes("linux")) return "Linux";
    if (uaString.includes("cros")) return "Chrome OS";
    return "Unknown";
  }
}

const useragentParser = new UseragentParser();
export { UseragentParser, useragentParser };